import commonMixin from '../../../mixins/_common';
import modalMixin from '../../../mixins/_modal';
import flashMessageMixin from '../../../mixins/_flash_messages';
import modalCustomPageSelecter from '../../_modal_custom_page_selecter';
import partsPreview from './_parts_preview';
import templateSelecter from '../../_template_selecter';
import { eventBus } from '@/helpers/_event_bus';

const TEMPLATE_TYPES = {
    'build_store': 'ストアトップ用',
    'item': '商品ページ用',
    'custom_page': 'カスタムページ用'
};

/**
 * コピーパーツ選択コンポーネント
 */
export default {
    name: 'CopyPartsSelecter',
    template: '#copy_parts_selecter_template',
    data() {
        return {
            // ページデザインデータ
            page_template: {},
            // 表示モード(初期値はmenu)
            display_mode: 'menu',
            // テンプレート取得先
            template_type: 'build_store'
        };
    },
    props: {
        // 呼び出し元ページ
        type: {
            type: String,
            require: true,
            validator: function (value) {
                return ['build_store', 'item', 'custom_page'].indexOf(value) !== -1;
            }
        },
        // 編集ID
        dist_edit_id: {
            type: [String, Number],
            default: '',
            require: false
        },
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin,
    ],
    components: {
        // カスタムページ選択コンポーネント
        'modal-custom-page-selecter': modalCustomPageSelecter,
        // パーツプレビューコンポーネント
        'parts-preview': partsPreview,
        // テンプレート選択コンポーネント
        'template-selecter': templateSelecter
    },
    created: function () {
        // イベントバスで商品選択結果を受け取る
        eventBus.$on('result_for_copy_parts_selecter', (result) => {
            this.previewPage('item', result.item_code);
        });
    },
    computed: {
        template_types: function () {
            return TEMPLATE_TYPES;
        }
    },
    emits: ['add-copied-parts'],
    methods: {
        // 商品一覧コンポーネントを開く
        openItemSearch: function () {
            eventBus.$emit('open_modal_item_search', {
                'from': 'copy_parts_selecter'
            });
        },
        // カスタムページ選択コンポーネントを開く
        openModalCustomPageSelecter: function () {
            this.$refs.modalCustomPageSelecter.openModal();
        },
        // プレビューを表示する
        previewPage: async function (type, key = null, template = {}) {
            // 初期化
            this.page_template = {};
            switch (type) {
                case 'template':
                    // template_typeに応じて必要データを抜き出す
                    const freetext = (this.template_type === 'item') ? template['additional_config'] : template['freetext'];
                    this.page_template = freetext;
                    // パーツ選択モーダルを開く
                    this.$refs.partsPreview.open();
                    break;

                // build_store, item, custom_page
                default:
                    this.setpreviewData(type, key);
                    break;
            }
        },
        // プレビュー表示データのセット
        setpreviewData: async function (type, key) {
            const itemCode = (type === 'item') ? key : null;
            const pageKey = (type === 'custom_page') ? key : null;

            try {
                // パーツデータを取得
                const templateData = await this.getPageDesign(type, itemCode, pageKey);

                // 対象ページがアプリに存在するか
                if (!(templateData && templateData.template.parts.length > 0)) {
                    swal('このページは、Magnetでデザインを作成していないためコピーできません');
                    return;
                }
                this.page_template = templateData.template;
                // パーツ選択モーダルを開く
                this.$refs.partsPreview.open();

            } catch (e) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: this.getCatchMessage(e),
                });
            }

        },
        // ページデータを取得する
        getPageDesign: async function (type, itemCode, pageKey) {
            try {
                this.$_loading();
                const response = await axios.get('/get_page_design', {
                    params: {
                        type: type,
                        item_code: itemCode,
                        page_key: pageKey
                    }
                });
                return response.data.template_data;
            } finally {
                this.$_unloading();
            }
        },
        // コピーされたパーツを親に通知する
        emitAddCopiedParts: async function (selected_parts_index_list, is_copy_all) {
            if (selected_parts_index_list.length) {
                // コピーされたパーツを取得
                const copiedParts = this.page_template.parts.filter((_, index) => selected_parts_index_list.includes(index));
                // 全体設定コピーがONならパーツ情報を除去して渡す
                let copiedDesign = null;
                if (is_copy_all) {
                    copiedDesign = this.page_template;
                    delete copiedDesign.parts;
                }
                // 親に通知
                this.$emit('add-copied-parts', copiedParts, copiedDesign);
            }
            // 設定値の破棄
            this.destroyClose();
        },
        // 設定値を破棄(初期化)してモーダルを閉じる
        destroyClose: function () {
            this.display_mode = 'menu';
            this.template_type = 'build_store';
            this.page_template = {};
            // モーダルを閉じる
            this.close();
        }
    },
};
